import { useEffect, useState } from "react";
import { FileText, Loader2, LogOut } from "lucide-react";
import Logo from "./Logo";

const TOKEN_KEY = "leutelia_token";

export default function RefertoCondiviso({ token, auth }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let obj = null;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/share/report/${encodeURIComponent(token)}/pdf`, { headers: { Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY)}` } })
      .then(async (r) => { if (!r.ok) { let d; try { d = (await r.json()).detail; } catch { d = r.statusText; } throw new Error(typeof d === "string" ? d : "Referto non disponibile"); } return r.blob(); })
      .then((b) => { obj = URL.createObjectURL(b); setUrl(obj); })
      .catch((e) => setErr(e.message));
    return () => { if (obj) URL.revokeObjectURL(obj); };
  }, [token]);
  return (
    <div className="min-h-screen bg-brand-cream flex flex-col" data-testid="referto-condiviso">
      <header className="bg-brand-green text-brand-cream px-6 py-4 flex items-center gap-4 border-b-[3px] border-brand-gold">
        <Logo />
        <div className="ml-auto text-[12.5px] text-brand-cream/80 flex items-center gap-3">{auth?.user?.email}<a href="/" className="underline flex items-center gap-1"><LogOut size={13} /> Vai a LEUTELIA</a></div>
      </header>
      <main className="flex-1 flex flex-col p-4 sm:p-6 max-w-[1200px] w-full mx-auto">
        <div className="flex items-center gap-2 mb-3 text-brand-ink"><FileText size={18} className="text-brand-gold" /><h1 className="font-serif text-[22px]">Referto condiviso</h1><span className="text-[12px] text-brand-muted">visibile solo con accesso LEUTELIA approvato</span></div>
        {err && <div className="bg-white border border-brand-maroon/30 rounded-xl p-5 text-[13.5px] text-brand-maroon" data-testid="referto-errore">{err}</div>}
        {!err && !url && <div className="text-brand-muted text-[13px] flex items-center gap-2"><Loader2 size={14} className="animate-spin text-brand-gold" /> Stiamo aprendo il referto…</div>}
        {url && <><iframe title="Referto" src={url} className="flex-1 min-h-[75vh] w-full rounded-xl border border-brand-gold/30 bg-white" data-testid="referto-pdf" /><a href={url} download="LEUTELIA_referto.pdf" className="mt-3 self-start h-9 px-4 rounded-lg bg-brand-green text-brand-cream text-[13px] font-semibold inline-flex items-center" data-testid="referto-scarica">Scarica il PDF</a></>}
      </main>
    </div>
  );
}
